import { css } from '@emotion/react';

import { VIDEOPLAYER_FOCUS_OUTLINE_THICKNESS } from 'bundles/video-player/constants';

export const styles = {
  videoPlayer: css`
    .vjs-waiting {
      .vjs-loading-spinner {
        z-index: 10000000;
      }
    }

    .vjs-react {
      font-family: OpenSans, Arial, sans-serif;

      /* Player background-color defaults to black */
      background-color: transparent;
    }

    .vjs-react .vjs-overlay {
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
      background-color: rgb(0 0 0 / 75%);
      z-index: 3;
      padding-top: 0;

      .coursera-assess-assessment-in-video {
        .coursera-assess-style-question-in-video {
          padding: 36px !important;
        }
      }
    }

    .vjs-react .vjs-poster {
      /* Poster defaults to black background. Make it transparent so it works with any color video player background. */
      background-color: transparent;
    }

    .vjs-react.vjs-coursera-skin.vjs-coursera-phoenix-skin {
      border-radius: var(--cds-border-radius-200);

      /* Cover up the background that scrolls behind the video player
         Because the outline appears outside its container, we need to leave space around the container to prevent the outline being cut off.
         Temporary fix; will change to allocate space inside the container for the outline */
      outline: ${VIDEOPLAYER_FOCUS_OUTLINE_THICKNESS}px solid var(--cds-color-neutral-background-primary) !important;

      &:focus {
        /* !important is needed to override the !important styles
           used by the legacy implementation */
        outline: ${VIDEOPLAYER_FOCUS_OUTLINE_THICKNESS}px solid #82a8e1 !important;
      }

      .vjs-mouse-display {
        .vjs-time-tooltip {
          top: -35px;
          font-size: 13px;
          border-radius: 1px;
          background-color: #111;
        }
      }

      .vjs-volume-panel {
        &:hover {
          .vjs-volume-control {
            width: 3em;
            height: 8em;
            display: block;
          }
        }
      }

      .vjs-volume-control {
        transition: none;
        height: 0;
        width: 0;
        display: none;
      }

      .vjs-progress-holder {
        margin: 0;
      }

      .vjs-text-track {
        font-size: 1.8em;
      }

      .vjs-control-bar {
        height: 35px;
      }

      .vjs-menu {
        margin-bottom: 15px;
      }

      .vjs-tech {
        z-index: 1;
      }
    }

    /* Ensures the text tracks managed by video.js are shown on top of the video player */
    .vjs-text-track-display {
      z-index: 2;

      .vjs-text-track-cue {
        /* Unfortunately, since the styles are applied inline, we need to use !important to override them */
        top: calc(100% - 110px) !important;

        > div {
          background-color: rgba(0 0 0 / 80%) !important;
        }
      }
    }
  `,
};
